<template>
    <div class="nav_bar" :class="theme">
        <div class="logo">
            <img src="../image/common/logo.png">
            <div class="text">闪显</div>
        </div>
        <div class="placeholder"></div>
        <div class="operation_wrapper">
            <div class="navs__list">
                <div class="item">
                    <RouterLink class="link" to="/">首页</RouterLink>
                </div>
                <div class="item">
                    <RouterLink class="link" to="/numverify">号码认证</RouterLink>
                </div>
                <div class="">
                    <img src="../image/common/hot.png" style="width:40px; height:40px;">
                </div>
                <div class="item">
                    <RouterLink class="link" to="/flashLetter">来电名片</RouterLink>
                </div>
                <div class="item">
                    <RouterLink class="link" to="/smsverify">logo短信</RouterLink>
                </div>
                <div class="item">
                    <RouterLink class="link" to="/messagesend">短信发送</RouterLink>
                </div>
                <div class="item">
                    <RouterLink class="link" to="/aboutus">关于我们</RouterLink>
                </div>
                <div class="item">
                    <RouterLink class="link" to="/contactus">联系我们</RouterLink>
                </div>
            </div>
            <div class="navs__list" v-if="route.path == '/' || route.path == '/messagesend' || route.path == '/flashLetter'">
                <div class="item">
                    <div class="link" @click="handleJumpLoginPage">登录</div>
                </div>
                <div class="item">
                    <div class="link" @click="handleJumpRegistePage">注册</div>
                </div>
            </div>
            <div class="navs__list">
                <div class="item">
                    咨询热线：0755-23760429
                </div>
            </div>
        </div>
    </div>
    <div class="place_bar">

    </div>
</template>

<script setup>
import { nextTick, onMounted, onUnmounted, ref } from 'vue';
import { RouterLink, useRoute } from 'vue-router'

const route = useRoute()
const theme = ref('white')

let observer;

onMounted(() => {
    // 注册观察者
    observer = new IntersectionObserver(entries => {
        for (let index = 0; index < entries.length; index++) {
            // 观察者返回的对象
            const element = entries[index]
            console.log(element)
            if (element.isIntersecting) {
                theme.value = 'white'
            } else {
                theme.value = 'black'
            }
        }
    })

    nextTick(() => {
        const dom = document.querySelector('.background__block')
        dom && observer.observe(dom)
    })
})

// 断开所有观察
onUnmounted(() => {
    observer.disconnect()
})

const handleJumpLoginPage = () => {
    window.open('https://agent.shanxianyun.com/#/login','_blank')
}
const handleJumpRegistePage = () => {
    window.open('https://agent.shanxianyun.com/#/register','_blank')
}

</script>

<style lang="scss" scoped>
.place_bar {
    height: 77px;
}

.nav_bar {
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    min-width: 800px;
    font-weight: 700;
    padding: 35px 140px 0 140px;
    background-color: #ffffff00;
    transition: background-color 0.5s ease-in-out, top 0.35s linear;

    .logo {
        //width: 87px;
        height: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
        // gap: 6px;

        img {
            width: 40px;
        }

        .text {
            //width: 40px;
            height: 28px;
            font-size: 20px;
            font-weight: 600;
            color: #fff;
            line-height: 28px;
            margin-left: 6px;
        }
    }

    .placeholder {
        flex: 1;
    }

    .operation_wrapper {
        display: flex;
        // gap: 12px;

        .navs__list {
            font-size: 14px;
            height: 42px;
            display: flex;
            justify-content: center;
            align-items: center;
            // gap: 24px;
            padding: 0 24px;
            background-color: #ffffff4d;
            border-radius: 36px;
            color: #fff;
            font-weight: 400;
            font-size: 12px;
            margin-left: 12px;
            &:first-child {
                margin-left: 0;
            }

            .item {
                text-align: center;
                color: inherit;
                margin-left: 24px;
                &:first-child {
                    margin-left: 0;
                }

                .link {
                    font-weight: 400;
                    font-family: PingFang SC;
                    text-decoration: none;
                    color: inherit;
                    font-weight: inherit;
                    font-size: inherit;
                    cursor: pointer;
                }
            }
        }
    }
}

.white {
    background-color: #ffffff00;
}

.black {
    background-image: url("../image/common/background.png");
    padding-top: 15px;
    padding-bottom: 15px;
    box-shadow: 0 5px 15px 0 rgba(0, 0, 0, .15);

    .logo .text{
        color: #fff;
    }

    .operation_wrapper .navs__list{
        color: #fff;
    }
}
</style>